export default "<span class=\"vm-icon\"></span>"